export default (to, duration = 300, element = window) => {
                        //to work in safari
    var start         = document.body.scrollTop + document.documentElement.scrollTop,
      change         = to - start,
      currentTime    = 0,
      increment	   = 20

   var easeInOutQuad = function (t, b, c, d) {
      t /= d/2
      if (t < 1) return c/2*t*t + b
      t--
      return -c/2 * (t*(t-2) - 1) + b
   }

   var animateScroll = function() {
      currentTime += increment
      var val = easeInOutQuad(currentTime, start, change, duration)
      element.scrollTo(0, val)
      if(currentTime < duration) {
         setTimeout(animateScroll, increment);
      }
   }

   animateScroll()
}

export const calcDistanceElement = element => element.offsetParent.offsetTop + element.offsetTop

export const getPosition = element => {
    let xPosition = 0;
    let yPosition = 0;

    window.elementDistance = element

    while(element) {
        xPosition += element.offsetLeft;
        yPosition += element.offsetTop;
        element = element.offsetParent;
    }

    return { x: xPosition, y: yPosition };
}



// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/ScrollTo/index.js